export default __webpack_public_path__ + "static/media/icon-arrow-chart.65fd187a.svg";